module.exports = __webpack_public_path__ + "fonts/iconfont.40c05a45.woff2";